(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-qb-search]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) panel.querySelector('input')?.focus();
      });
    });
    scope.querySelectorAll('[data-qb-card-hover]').forEach(template => {
      if (template.dataset.ready) return;
      template.dataset.ready = 'true';
      const link = template.closest('a');
      const load = () => {
        if (!matchMedia('(min-width: 750px)').matches || !template.isConnected) return;
        template.replaceWith(template.content.cloneNode(true));
        link.removeEventListener('pointerenter', load);
        link.removeEventListener('focusin', load);
      };
      link.addEventListener('pointerenter', load);
      link.addEventListener('focusin', load);
    });
    scope.querySelectorAll('[data-qb-videos]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const videos = [...section.querySelectorAll('video')];
      const button = section.querySelector('[data-qb-video-toggle]');
      let enabled = !matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData;
      const visible = new Set();
      const loadPoster = video => {
        if (!video.dataset.qbPoster) return;
        video.poster = video.dataset.qbPoster;
        delete video.dataset.qbPoster;
      };
      const posterObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          loadPoster(entry.target);
          posterObserver.unobserve(entry.target);
        });
      }, {rootMargin: '300px'});
      videos.forEach(video => posterObserver.observe(video));
      const sync = () => {
        button.textContent = enabled ? button.dataset.pause : button.dataset.play;
        videos.forEach(video => {
          video.muted = true;
          if (enabled && visible.has(video) && !document.hidden) video.play().catch(() => {});
          else video.pause();
        });
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
        sync();
      }, {threshold:.25});
      videos.forEach(video => observer.observe(video));
      button.addEventListener('click', () => { enabled = !enabled; sync(); });
      document.addEventListener('visibilitychange', sync);
      sync();
    });
    scope.querySelectorAll('.qb-products').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const rail = section.querySelector('[data-qb-rail]');
      const prev = section.querySelector('[data-qb-prev]');
      const next = section.querySelector('[data-qb-next]');
      if (!rail || !prev || !next) return;
      const update = () => {
        prev.disabled = rail.scrollLeft <= 1;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      prev.addEventListener('click', () => rail.scrollBy({left: -rail.clientWidth * .8, behavior: 'smooth'}));
      next.addEventListener('click', () => rail.scrollBy({left: rail.clientWidth * .8, behavior: 'smooth'}));
      rail.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(rail);
      update();
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.qb-menu[open],.qb-filter-panel[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.qb-menu[open],.qb-filter-panel[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
    const panel = document.getElementById('qb-search-panel');
    if (panel && !panel.hidden) {
      panel.hidden = true;
      const button = document.querySelector('[data-qb-search]');
      button?.setAttribute('aria-expanded','false');
      button?.focus();
    }
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  // Style the embedded order form locally; its account settings remain unchanged.
  const styledOrderButtons = new WeakSet();
  const observedOrderForms = new WeakSet();
  const orderShortcut = document.getElementById('qb-mobile-order');
  const styleOrderForm = () => {
    const form = document.getElementById('es-form');
    if (form) {
      const autocomplete = {first_name:'name',city:'address-level2',address:'street-address',phone:'tel'};
      Object.entries(autocomplete).forEach(([name,value]) => form.querySelector(`input[name="${name}"]`)?.setAttribute('autocomplete',value));
      form.querySelector('input[name="phone"]')?.setAttribute('inputmode','tel');
      if (orderShortcut && !observedOrderForms.has(form)) {
        observedOrderForms.add(form);
        new IntersectionObserver(([entry]) => { orderShortcut.hidden = entry.isIntersecting; }, {rootMargin:'-90px 0px -70px 0px'}).observe(form);
      }
    }
    document.querySelectorAll('#es-form-button').forEach(button => {
      if (styledOrderButtons.has(button)) return;
      styledOrderButtons.add(button);
      Object.entries({'background':'#45483a','border-color':'#45483a','border-radius':'0','box-shadow':'none','font-style':'normal','font-weight':'400','min-height':'56px'}).forEach(([key,value]) => button.style.setProperty(key,value,'important'));
    });
  };
  if (document.body.classList.contains('qb-template-product')) {
    new MutationObserver(styleOrderForm).observe(document.querySelector('main'), {childList:true,subtree:true});
    styleOrderForm();
  }
  setup();
})();
